import { AuthSession } from 'api/AuthSession'
import { AuthRoute } from 'components/AuthRoute'
import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import AxiosNavigation from 'hooks/useAxiosNavigation'
import { CreateAccount } from 'pages/CreateAccount'
import { ForgotPassword } from 'pages/ForgotPassword'
import { Home } from 'pages/Home'
import { Login } from 'pages/Login'
import { NotFound } from 'pages/NotFound'
import { PayoutStatements as PayoutStatementsPage } from 'pages/PayoutStatements'
import { UserAccount } from 'pages/UserAccount'
import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import LoaderProvider from 'utils/context/LoaderContext'
import { StatementsProvider } from 'utils/context/StatementsContext'
import './App.scss'
import { SetupAccount } from 'pages/SetupAccount'
import { ProductBalancingStatements } from 'pages/ProductBalancingStatements'
import { Error } from 'pages/ErrorPage'


function App() {

    useEffect(() => {
        const unloadCallback = (event) => {
            localStorage.removeItem('isTimeout')
        }

        window.addEventListener("beforeunload", unloadCallback)
        return () => window.removeEventListener("beforeunload", unloadCallback)
    }, [])

    return (
        <LoaderProvider>
            <AuthSession>
                <StatementsProvider>
                    <AxiosNavigation />
                    <div className="App">
                        <Header />
                        <Routes>
                            <Route
                                path="/"
                                element={
                                    <AuthRoute>
                                        <Home />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/dashboard"
                                element={
                                    <AuthRoute>
                                        <Home />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/product-balancing/:type/report"
                                element={
                                    <AuthRoute>
                                        <ProductBalancingStatements />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="/payout/:type/report"
                                element={
                                    <AuthRoute>
                                        <PayoutStatementsPage />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="account/:menu"
                                element={
                                    <AuthRoute>
                                        <UserAccount />
                                    </AuthRoute>
                                }
                            />
                            <Route
                                path="account/organization/:menu"
                                element={
                                    <AuthRoute>
                                        <UserAccount />
                                    </AuthRoute>
                                }
                            />
                            <Route path="/signin" element={<Login />} />
                            <Route
                                path="/create-account"
                                element={<CreateAccount />}
                            ></Route>
                            <Route
                                path="/forgot-password"
                                element={<ForgotPassword />}
                            />
                            <Route
                                path="/setup-account"
                                element={<SetupAccount />}
                            />
                            <Route path="/error" element={<Error />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                        <ToastContainer />
                        <Footer />
                    </div>
                </StatementsProvider>
            </AuthSession>
        </LoaderProvider>
    )
}

export default App
